module.exports = __webpack_public_path__ + "static/flags/LI-067b43f59e5474cccb5fb09cc254bbef.gif";